import { isPoweruser } from 'js/lib/user';

import { MAX_POLLING_COUNT } from 'bundles/authoring-ai-tools/lib/constants';
import type { PollingArgs } from 'bundles/authoring-ai-tools/lib/types';
import ContentAccelerationEpic from 'bundles/epic/clients/ContentAcceleration';

export const coachPromptEditorUrl = (coachMode: string, coachAction: string) =>
  // eslint-disable-next-line no-restricted-syntax
  `https://retool.coursera.org/apps/197bbec6-58e7-11ef-b7c5-13a057f701e1/coach-platform/Coach%20Config#action=${coachAction}&mode=${coachMode}`;

export const markdownFilename = (toolRoute: string) => {
  const d = new Date();
  const dateString = d.toISOString().split('T')[0];
  return `${toolRoute}_${dateString}.md`;
};

/**
 * Determines if polling should start based on the polling args
 * @param param0 the polling args
 * @returns true if the polling should start, false otherwise
 */
export const shouldStartPolling = ({
  isPolling,
  isLoading,
  hasError,
  asyncTaskStatus,
  pollingCount,
}: PollingArgs): boolean => {
  if (isLoading || isPolling || hasError) {
    return false;
  }
  return !asyncTaskStatus && pollingCount === 0;
};

/**
 * Detgermines if polling should stop based on the polling args
 * @param param0 the polling args
 * @returns true if the polling should stop, false otherwise
 */
export const shouldStopPolling = ({ isPolling, hasError, asyncTaskStatus, pollingCount }: PollingArgs): boolean => {
  if (!isPolling) {
    return false;
  }
  return hasError || !!asyncTaskStatus || pollingCount >= MAX_POLLING_COUNT;
};

/**
 * Determines if a user can access the CA tools.
 * To access, a user must either a) be an SU or b) be added to the following EPIC experiment
 * @returns true if the the user can access, false otherwise
 */
export const canAccessContentAccelerator = () => {
  return isPoweruser() || ContentAccelerationEpic.get('enableCA');
};
